import { Injectable } from '@angular/core';
import { Observable, Subject, pipe } from 'rxjs';
import { map } from 'rxjs/operators';

import { ResponseWrapper } from '@library/common/http';

import { Shipment } from '@library/common/models';

import { CacheService } from '@library/core/services';

@Injectable({
   providedIn: 'root'
})
export class ShipmentDetailsService {

   url = 'shipment';

   refresh$: Subject<void> = new Subject();

   constructor( private cache: CacheService ) { }

   load( hawb: any ): Observable<Shipment<any, any>> {
      return this.cache.request<ResponseWrapper<Shipment<any, any>>, Shipment<any, any>>({
         url: this.url + '?hawb=' + hawb,
         refresher: this.refresh$,
         pipe: pipe(
            map( rw => rw.response.collection[0] ),
         ),
         useLambda: true,
      });
   }

   viewFreightBooking( fb: any ): Observable<any> {
      return this.cache.request<ResponseWrapper<any>, any>({
         url: 'fb?id=' + fb,
         refresher: this.refresh$,
         pipe: pipe(
            map( rw => rw.response.collection[0] ),
         ),
         useLambda: true
      });
   }

   resetDetails( hawb: any, refresh?: boolean ) {
      this.cache.clearSet( this.url + '?hawb=' + hawb, refresh );
      // Also clear freight booking cache entries and set noCache flag
      const fbKeys = [...this.cache.subscriptions.keys()].filter(key => key.includes('/fb'));
      this.cache.clearSet('/fb');
      if (refresh) {
         fbKeys.forEach(key => this.cache.noCache.set(key, true));
      }
   }

   reset() {
      this.cache.clearSet( this.url );
   }
}
